/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import DownArrow from "./DownArrow";

export default DownArrow;
